import { Typography } from '@/app/common/Typography';
import { Button } from '@workspace/ui/common';
import { cn } from '@workspace/lib';

interface AskGregPromptListProps {
  quickPromptsTitle: string;
  quickPrompts: readonly { text: string }[];
  onPromptClick: (promptText: string) => void;
}

export function AskGregPromptList({ quickPromptsTitle, quickPrompts, onPromptClick }: AskGregPromptListProps) {
  return (
    <div className={cn('w-full lg:flex-1 gap-sm md:gap-md flex flex-col items-center')}>
      <Typography variant="button" className="text-center font-heading self-stretch">
        {quickPromptsTitle}
      </Typography>

      <div className={cn('w-full lg:w-auto gap-xs self-stretch flex flex-col items-start')}>
        {quickPrompts.map((prompt, index) => (
          <Button
            key={index}
            variant="primary"
            overrideClasses
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onPromptClick(prompt.text);
            }}
            className={cn(
              'group w-full px-lg py-button gap-3xs self-stretch rounded-round border border-primary hover:border-primary-500 active:border-2 active:border-primary bg-white cursor-pointer flex justify-center items-center max-sm:text-sm text-primary font-body font-semibold leading-5 lg:leading-6',
            )}
            aria-label={`Ask: ${prompt.text}`}
          >
            <span className={cn('pointer-events-none select-none group-hover:text-primary-500 group-active:font-bold')}>
              {prompt.text}
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
}
